import React from 'react';
import PropTypes from 'prop-types';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import 'rc-menu/assets/index.css';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
     .rc-menu,
     .rc-menu-submenu {
         z-index: 555;
     }
    
     .sl-menu > li {
         color: ${(props) => props.menuFontColor};
     }
    
     .rc-menu-sub > li {
         color: ${(props) => props.menuFontColor};
     }
     
     /* React components */
     .rc-menu,
     .rc-menu-item,
     .rc-menu-submenu,
     .rc-menu a {
         /* Same as normal bold text */
         font-weight: 700;
         font-size: 16px;
         line-height: 20px;
         letter-spacing: normal;
         color: ${(props) => props.menuFontColor};
     }
    
     .rc-menu-submenu > .rc-menu {
         background-color: ${(props) =>
           props.menuDropdownBackgroundColor} !important;
     }
           
     .rc-menu-horizontal > .rc-menu-submenu-active,
     .rc-menu-horizontal > .rc-menu-item-active {
         color: ${(props) => props.menuItemHoverColor} !important;
     }
     
     .sl-menu a,
      rc-menu-submenu-title {
         text-decoration: none; 
         padding: 12px 20px !important;
     }
`;

function handleClick(info) {}
function onOpenChange(info) {}

const subMenuTransform = (data) => {
  return data.map((item) => {
    if (item.children !== null) {
      return (
        <SubMenu
          title={<span className='submenu-title-wrapper'>{item.title}</span>}
          key={item.id}
          popupOffset={[10, 15]}
        >
          {subMenuTransform(item.children)}
        </SubMenu>
      );
    } else {
      return (
        <MenuItem key={item.id}>
          <a className='font-size-normal weight-bold' href={item.url}>
            {item.title}
          </a>
        </MenuItem>
      );
    }
  });
};

class CommonMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      overflowedIndicator: undefined
    };
  }

  toggleChildren = () => {
    // this.setState({
    //   children: this.state.children === children1 ? children2 : children1
    // });
  };

  toggleOverflowedIndicator = () => {
    // this.setState({
    //   overflowedIndicator:
    //     this.state.overflowedIndicator === undefined
    //       ? customizeIndicator
    //       : undefined
    // });
  };

  render() {
    const {
      triggerSubMenuAction,
      menuFontColor,
      menuItemHoverColor,
      menuDropdownBackgroundColor,
      menuBackgroundColor,
      menu: children
    } = this.props;
    const { overflowedIndicator } = this.state;

    return (
      <div>
        <GlobalStyle
          menuFontColor={menuFontColor}
          menuBackgroundColor={menuBackgroundColor}
          menuItemHoverColor={menuItemHoverColor}
          menuDropdownBackgroundColor={menuDropdownBackgroundColor}
        />

        {this.props.updateChildrenAndOverflowedIndicator && (
          <div>
            <button onClick={this.toggleChildren}>toggle children</button>
            <button onClick={this.toggleOverflowedIndicator}>
              toggle overflowedIndicator
            </button>
          </div>
        )}
        <Menu
          onClick={handleClick}
          triggerSubMenuAction={triggerSubMenuAction}
          onOpenChange={onOpenChange}
          selectedKeys={['0']}
          mode={this.props.mode}
          openAnimation={this.props.openAnimation}
          defaultOpenKeys={this.props.defaultOpenKeys}
          overflowedIndicator={overflowedIndicator}
          className={'sl-menu'}
        >
          <MenuItem style={{ display: 'none' }} />
          {children &&
            children.map((item) => {
              if (item.children !== null) {
                return (
                  <SubMenu
                    title={
                      <span className='submenu-title-wrapper'>
                        {item.title}
                      </span>
                    }
                    key={item.id}
                  >
                    {subMenuTransform(item.children)}
                  </SubMenu>
                );
              } else {
                return (
                  <MenuItem key={item.id}>
                    <a href={item.url}>{item.title}</a>
                  </MenuItem>
                );
              }
            })}
        </Menu>
      </div>
    );
  }
}

CommonMenu.propTypes = {
  mode: PropTypes.string,
  openAnimation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  triggerSubMenuAction: PropTypes.string,
  defaultOpenKeys: PropTypes.arrayOf(PropTypes.string),
  updateChildrenAndOverflowedIndicator: PropTypes.bool,
  menu: PropTypes.array,
  menuFontColor: PropTypes.string,
  menuItemHoverColor: PropTypes.string,
  menuBackgroundColor: PropTypes.string,
  menuDropdownBackgroundColor: PropTypes.string
};

export default CommonMenu;
